<template>
    <div>
        <v-container class="pa-5"  >
            <h1 class="display-3 pa-5 indigo darken-1 white--text rounded-tl-xl" > Feriados/Dias não úteis</h1>
            <v-div class="ma-5">
                <FeriadoDialog @recarregarLista="carregarLista()"/>
            </v-div>
            <v-divider></v-divider>
            <v-list>
                 <v-layout row>
                    <v-list-item v-for="item in feriados" :key="item.dia" >
                        <v-flex xs12 sm12 class="ma-3">
                        <v-card class="pa-5">
                            
                            <v-card-title class="grey lighten-3">
                                {{item.dia}} 
                                <v-spacer></v-spacer>
                                <v-list-item-icon>
                                    <v-btn text small @click="excluirFeriado(item)">
                                        <v-icon>fa fa-trash</v-icon>

                                    </v-btn>
                                </v-list-item-icon>  
                            </v-card-title>
                            <v-list-item-content>
                                <v-card class="pa-3 indigo"><span class="white--text" style="font-weight: 500">Barbeiros de folga</span></v-card>
                                <v-divider></v-divider>
                                <v-div class="mt-5 px-5">
                                    
                                    <div v-for="barbeiro in item.barbeiros" :key="barbeiro.id" >
                                        <v-btn text>
                                            <v-icon left>fa fa-address-book</v-icon><span>{{ barbeiro.nome }}</span>
                                        </v-btn>
                                    </div>
                                </v-div>
                            </v-list-item-content>
                          
                        </v-card>

                        </v-flex>
                        
                    </v-list-item>
                </v-layout>
            </v-list>
        </v-container>

    </div>
</template>

<script>
import FeriadoDialog from './Components/FeriadoDialog'
import {refFeriados} from '@/firebaseConfig'

    export default {
        components:{
            FeriadoDialog
        },
        data(){
            return{
                feriados: [],
                refFeriados: refFeriados,
            }
        },
        methods:{
            carregarLista(){
                this.feriados = []
                console.log("carregando");
                this.refFeriados.orderBy("data","desc").limit(15).get().then(snap => {
                    snap.forEach(doc =>{
                        let dia = doc.data().data.split("-")[2]
                        let mes = doc.data().data.split("-")[1]
                        let ano = doc.data().data.split("-")[0]
                        let diaM = dia + "/" + mes + "/" + ano
                        this.feriados.push({...doc.data(), dia: diaM})
                    });
                });

            },
            excluirFeriado(item){
                 if(confirm("Deseja apagar mesmo?")){
                    this.refFeriados.doc(item.id).delete().then(() =>{
                    console.log("Apagado!");
                    this.$toasted.global.defaultSuccess("Apagado com sucesso!");
                    /*var index = this.items.indexOf(item);
                    if (index > -1) {
                        this.items.splice(index, 1);
                    }*/
                this.carregarLista();
                });
                 }
            }
        },
        created(){
            this.carregarLista()
        }
    }
</script>

<style lang="scss" scoped>

</style>